import { API, graphqlOperation } from "aws-amplify";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader } from "@aws-amplify/ui-react";

import HolidayForm from "components/holidays/HolidayForm";
import { updateHoliday } from "graphql/mutations";
import { getHoliday } from "graphql/queries";

const HolidayUpdateForm = ({ holidayId, onSuccess }) => {
  const navigate = useNavigate();
  const [holiday, setHoliday] = useState();

  async function onSubmit(valuesParam) {
    try {
      const {
        date,
        name,
      } = valuesParam;

      await API.graphql({
        query: updateHoliday.replaceAll("__typename", ""),
        variables: {
          input: {
            id: holidayId,
            date,
            name,
          },
        },
      });

      toast.success(strings.successUpdated);
      if (onSuccess) onSuccess();
      else navigate("/holidays");
    } catch (err) {
      toast.error(strings.responses[err]);
    }
  }

  async function fetchHoliday(id) {
    try {
      const holidayData = await API.graphql(graphqlOperation(getHoliday, { id }));
      const holidayItem = holidayData.data.getHoliday;
      if (!holidayItem) {
        toast.error(strings.responses.errorFetch);
        navigate("/holidays");
        return;
      }
      setHoliday(holidayItem);
    } catch (err) {
      toast.error(strings.responses.errorFetch);
    }
  }

  useEffect(() => {
    fetchHoliday(holidayId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [holidayId]);

  if (!holiday) return <Loader />;

  return (
    <div>
      <HolidayForm onSubmit={onSubmit} type="update" initialValues={holiday} />
    </div>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Actualizar Día festivo",
    successUpdated: "Día festivo actualizado con éxito",
    responses: {
      errorFetch: "Error al consultar el día festivo",
    },
  },
});

export default HolidayUpdateForm;
